// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MainPage-module__container--P_TNQ {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 70vh;
    padding: 20px;
    text-align: center;
}

.MainPage-module__title--ujuzO {
    color: #6F879C;
    font-size: 26px;
    font-weight: 500;
    margin-bottom: 30px;
}

.MainPage-module__btnBox--gdFiz {
    display: flex;
    flex-direction: column;
    gap: 20px;
    justify-content: center;
    align-items: center;
}

.MainPage-module__gradientButton--kDX3I {
    width: 100%;
    max-width: 300px;
    height: 50px;
    margin-bottom: 15px;
    border-radius: 25px;
    background: linear-gradient(90deg, #0051DF, #8DA8FF);
    color: white !important;
    font-weight: 600;
    border: none;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    transition: transform 0.2s;

    &:active {
        transform: scale(0.98);
    }
}

.MainPage-module__outlineButton--f8I98 {
    width: 100%;
    max-width: 300px;
    height: 50px;
    border-radius: 25px;
    background: transparent;
    color: #0051DF !important;
    font-weight: 600;
    box-shadow: none;
    transition: transform 0.2s;
    text-transform: none !important;

    &:active {
        transform: scale(0.98);
    }
}

.MainPage-module__mainBox--ESvHz {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    align-items: center;
}

.MainPage-module__errorBox--Tfe5r>p {
    color: #BD0048;
    font-size: 26px;
    font-weight: 500;
    margin-bottom: 30px;
}`, "",{"version":3,"sources":["webpack://./src/pages/main-page/MainPage.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,oDAAoD;IACpD,uBAAuB;IACvB,gBAAgB;IAChB,YAAY;IACZ,wCAAwC;IACxC,0BAA0B;;IAE1B;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;IAChB,0BAA0B;IAC1B,+BAA+B;;IAE/B;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB","sourcesContent":[".container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    min-height: 70vh;\r\n    padding: 20px;\r\n    text-align: center;\r\n}\r\n\r\n.title {\r\n    color: #6F879C;\r\n    font-size: 26px;\r\n    font-weight: 500;\r\n    margin-bottom: 30px;\r\n}\r\n\r\n.btnBox {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 20px;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.gradientButton {\r\n    width: 100%;\r\n    max-width: 300px;\r\n    height: 50px;\r\n    margin-bottom: 15px;\r\n    border-radius: 25px;\r\n    background: linear-gradient(90deg, #0051DF, #8DA8FF);\r\n    color: white !important;\r\n    font-weight: 600;\r\n    border: none;\r\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n    transition: transform 0.2s;\r\n\r\n    &:active {\r\n        transform: scale(0.98);\r\n    }\r\n}\r\n\r\n.outlineButton {\r\n    width: 100%;\r\n    max-width: 300px;\r\n    height: 50px;\r\n    border-radius: 25px;\r\n    background: transparent;\r\n    color: #0051DF !important;\r\n    font-weight: 600;\r\n    box-shadow: none;\r\n    transition: transform 0.2s;\r\n    text-transform: none !important;\r\n\r\n    &:active {\r\n        transform: scale(0.98);\r\n    }\r\n}\r\n\r\n.mainBox {\r\n    margin-top: 20px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-content: center;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.errorBox>p {\r\n    color: #BD0048;\r\n    font-size: 26px;\r\n    font-weight: 500;\r\n    margin-bottom: 30px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MainPage-module__container--P_TNQ`,
	"title": `MainPage-module__title--ujuzO`,
	"btnBox": `MainPage-module__btnBox--gdFiz`,
	"gradientButton": `MainPage-module__gradientButton--kDX3I`,
	"outlineButton": `MainPage-module__outlineButton--f8I98`,
	"mainBox": `MainPage-module__mainBox--ESvHz`,
	"errorBox": `MainPage-module__errorBox--Tfe5r`
};
export default ___CSS_LOADER_EXPORT___;
